import { Cookie } from '@mercadona/mo.library.web-services/cookies'
import { TranslationService } from 'services/translation'

const {
  REACT_APP_COOKIE_DOMAIN,
  REACT_APP_USER_INFO,
  REACT_APP_DELIVERY_COOKIE,
} = process.env

export function setDeliveryAreaCookie(deliveryArea) {
  if (!deliveryArea || !deliveryArea.postalCode || !deliveryArea.warehouse) {
    return
  }

  Cookie.save(deliveryArea, REACT_APP_DELIVERY_COOKIE, REACT_APP_COOKIE_DOMAIN)
}

export function changeLanguageCookie(language) {
  const currentCookie = Cookie.get(REACT_APP_USER_INFO) || {}

  const availableLanguage = TranslationService.getAvailableLanguage(language)
  if (!availableLanguage) {
    return
  }

  currentCookie.language = availableLanguage

  Cookie.save(currentCookie, REACT_APP_USER_INFO, REACT_APP_COOKIE_DOMAIN)
}
